import AutoloadViews from '@galaxy/modules/Core/resources/js/AutoloadViews.js';

AutoloadViews.load('websiteForms::admin', require.context('./admin/', true, /^(.*)\.(js|vue)$/));
